import React, { useState } from 'react'
import './style.scss'
import { NavLink, Link, useHistory } from 'react-router-dom'
import { Icon, ModalEmpty } from './../../Layout'
import { useAuth } from './../../../context/Auth'
import { useTheme } from './../../../context/Theme'

function Sidebar({
    data,
    markerSelecionado,
}) {

    const { getUser, getMenu, removeUser } = useAuth()
    const { theme, toggleTheme } = useTheme()
    const history = useHistory()
    const [showProfileMenu, setShowProfileMenu] = useState(false)
    const [showLogoutModal, setShowLogoutModal] = useState(false)
    const usuario = getUser()
    const menuShow = String(getMenu())

    function handleLogout() {
        removeUser()
        window.location.href = '/'
    }

    const NavItem = ({ to, icon, label, exact = false }) => (
        <NavLink
            to={to}
            exact={exact}
            className="nav-item"
            activeClassName="active"
        >
            <Icon name={icon} />
            <span>{label}</span>
        </NavLink>
    )

    return (
        <nav className="sidebar">
            <div className="sidebar-header">
                <Link to="/dash" className="brand">
                    <img
                        src={theme === 'dark' ? '/assets/images/logo/logobranca.svg' : '/assets/images/logo/logo.svg'}
                        alt="Ambientar"
                        style={{ height: '24px', width: 'auto' }}
                    />
                </Link>
            </div>

            <div className="sidebar-body">
                {/* DASHBOARD */}
                <div className="nav-group">
                    <NavItem to="/dash" icon="ti-layout-grid2" label="Dashboard" />

                    {menuShow === '1' && (
                        <NavItem to="/intelligence-board" icon="ti-thought" label="Intelligence Board" />
                    )}

                    <NavItem to="/calendario" icon="ti-calendar" label="Calendário" />
                </div>

                {/* LANÇAMENTO */}
                <div className="nav-group">
                    <div className="group-title">Lançamento</div>
                    {menuShow !== '4' && <NavItem to="/cliente" icon="ti-user" label="Clientes" />}
                    <NavItem to="/licenca" icon="ti-clipboard" label="Licenças" />
                    <NavItem to="/condicionante" icon="ti-receipt" label="Condicionantes" />
                </div>

                {/* CADASTROS - Only for Admin (1) or Moderator (2) */}
                {(menuShow === '1' || menuShow === '2') && (
                    <div className="nav-group">
                        <div className="group-title">Cadastros</div>
                        <NavItem to="/ramoatividade" icon="ti-write" label="Atividade Amb." />
                        <NavItem to="/orgao" icon="ti-medall" label="Órgão Público" />
                        <NavItem to="/tiporegularizacao" icon="ti-marker" label="Tipo Regularização" />
                        <NavItem to="/localizacaofisica" icon="ti-pin" label="Localização Física" />
                        {menuShow === '1' && (
                            <NavItem to="/situacao" icon="ti-flag" label="Situação Licença" />
                        )}
                    </div>
                )}

                {/* INTEGRAÇÃO - Only for Admin (1) or Moderator (2) */}
                {(menuShow === '1' || menuShow === '2') && (
                    <div className="nav-group">
                        <div className="group-title">Integração</div>
                        <NavItem to="/dou" icon="ti-package" label="DOU" />
                    </div>
                )}

                {/* CONFIGURAÇÃO */}
                <div className="nav-group">

                    {menuShow === '1' && (
                        <>
                            <div className="group-title">Configurações</div>

                            <NavItem to="/colaborador" icon="ti-user" label="Colaboradores" />
                            <NavItem to="/perfil" icon="ti-settings" label="Perfil" />
                            {/* <NavItem to="/assinatura" icon="ti-credit-card" label="Assinatura" /> */}
                        </>
                    )}
                </div>

            </div>

            <div className="sidebar-footer">
                {showProfileMenu && (
                    <div className="profile-menu-popover">
                        {/* <div className="menu-item" onClick={() => { history.push('/perfil'); setShowProfileMenu(false); }}>
                            <Icon name="ti-settings" />
                            <span>Perfil</span>
                        </div> */}
                        {/* Dark Mode Toggle */}
                        {/* <div className="menu-item" onClick={() => { toggleTheme(); setShowProfileMenu(false); }}>
                            <Icon name="ti-light-bulb" />
                            <span>{theme === 'dark' ? 'Modo Claro' : 'Modo Escuro'}</span>
                        </div> */}
                        <div className="menu-item" onClick={() => { setShowProfileMenu(false); setShowLogoutModal(true); }}>
                            <Icon name="ti-power-off" />
                            <span>Sair</span>
                        </div>
                    </div>
                )}

                {showLogoutModal && (
                    <ModalEmpty
                        title="Confirmar Saída"
                        onClose={() => setShowLogoutModal(false)}
                        onSave={handleLogout}
                        nomeButtonSave="Sair do Sistema"
                        nomeButtonCancel="Cancelar"
                        setWidth="400px"
                    >
                        <div className="p-3 text-center">
                            <Icon name="ti-alert" style={{ fontSize: '48px', color: 'var(--color-success)', marginBottom: '16px', display: 'block' }} />
                            <p style={{ margin: 0, fontSize: '16px', color: 'var(--color-text-primary)' }}>
                                Deseja realmente sair do sistema?
                            </p>
                        </div>
                    </ModalEmpty>
                )}

                <div className={`user-profile ${showProfileMenu ? 'active' : ''}`} onClick={() => setShowProfileMenu(!showProfileMenu)}>
                    <img src={usuario.avatar || 'https://via.placeholder.com/32'} alt="User Avatar" />
                    <div className="user-info">
                        <span className="user-name">{usuario.nome}</span>
                        <span className="user-role">{menuShow === '1' ? 'Administrador' : 'Usuário'}</span>
                    </div>
                    <div className="expand-icon">
                        <Icon name={showProfileMenu ? "ti-angle-up" : "ti-angle-down"} />
                    </div>
                </div>
            </div>
        </nav>
    )
}

export default Sidebar